import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var getImageInfo = normalize.getImageInfo(function (args) {
  return isDingdingMiniapp ? dd.getImageInfo(args) : my.getImageInfo(args);
}, CONTAINER_NAME.ALIPAY);
export default getImageInfo;